// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Util$SmartcutsMacros = require("../../../../bs-utils/src/Util.bs.js");
var ExternalAccount$SmartcutsMacros = require("../../ExternalAccount.bs.js");
var ExtensionMessaging__FromTab$SmartcutsMacros = require("../../ExtensionMessaging__FromTab.bs.js");
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = require("./ContentScript__StateMachine__Shared__Types.bs.js");

var basicEvent_encode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_encode;

var basicEvent_decode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_decode;

function extractRespondToBgFromEvent($$event) {
  if ($$event.TAG === /* MessageFromExtension */0) {
    return $$event._1;
  }
  
}

function askBgScriptToFetchAuthToken(maybeExtensionId, param) {
  var sendMessage_FindExternalAccountById = maybeExtensionId !== undefined ? Curry._1(ExtensionMessaging__FromTab$SmartcutsMacros.FindExternalAccountById.encodeAndSendMessageToExtensionId, maybeExtensionId) : ExtensionMessaging__FromTab$SmartcutsMacros.FindExternalAccountById.encodeAndSendMessage;
  return Curry._1(sendMessage_FindExternalAccountById, /* FindExternalAccountById */{
                  _0: ExternalAccount$SmartcutsMacros.stringifyProvider(/* Google */0)
                }).then(function (result) {
                if (result.TAG !== /* Ok */0) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: /* ResponseErrorFromBg */{
                                _0: result._0
                              }
                            });
                }
                var _expired = result._0;
                if (!_expired) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: /* UserNeverAuthed */0
                            });
                }
                var _expired$1 = _expired._0;
                if (_expired$1.refreshedAt > Date.now() - 3600000) {
                  return Promise.resolve({
                              TAG: /* Ok */0,
                              _0: _expired$1.authToken
                            });
                }
                var sendMessage_GetOAuthToken = maybeExtensionId !== undefined ? Curry._1(ExtensionMessaging__FromTab$SmartcutsMacros.GetOAuthToken.encodeAndSendMessageToExtensionId, maybeExtensionId) : ExtensionMessaging__FromTab$SmartcutsMacros.GetOAuthToken.encodeAndSendMessage;
                return Curry._1(sendMessage_GetOAuthToken, /* GetOAuthToken */{
                              _0: true
                            }).then(function (result) {
                            if (result.TAG !== /* Ok */0) {
                              return Promise.resolve({
                                          TAG: /* Error */1,
                                          _0: /* ResponseErrorFromBg */{
                                            _0: result._0
                                          }
                                        });
                            }
                            var authToken = result._0;
                            if (!authToken) {
                              return Promise.resolve({
                                          TAG: /* Error */1,
                                          _0: /* DidNotGetOAuthToken */1
                                        });
                            }
                            var authToken$1 = authToken._0;
                            var sendMessage_SaveExternalAccount = maybeExtensionId !== undefined ? Curry._1(ExtensionMessaging__FromTab$SmartcutsMacros.SaveExternalAccount.encodeAndSendMessageToExtensionId, maybeExtensionId) : ExtensionMessaging__FromTab$SmartcutsMacros.SaveExternalAccount.encodeAndSendMessage;
                            return Curry._1(sendMessage_SaveExternalAccount, /* SaveExternalAccount */{
                                          _0: {
                                            provider: /* Google */0,
                                            authToken: authToken$1,
                                            refreshedAt: Date.now()
                                          }
                                        }).then(function (_response) {
                                        return Promise.resolve({
                                                    TAG: /* Ok */0,
                                                    _0: authToken$1
                                                  });
                                      });
                          });
              }).then(function (result) {
              if (result.TAG === /* Ok */0) {
                return Promise.resolve(result._0);
              }
              var message = result._0;
              if (typeof message === "number") {
                if (message !== 0) {
                  return Util$SmartcutsMacros.logAndRaiseJsError("Did not get auth token");
                } else {
                  return Promise.resolve(undefined);
                }
              } else {
                return Util$SmartcutsMacros.logAndRaiseJsError(message._0);
              }
            });
}

var Types;

exports.Types = Types;
exports.basicEvent_encode = basicEvent_encode;
exports.basicEvent_decode = basicEvent_decode;
exports.extractRespondToBgFromEvent = extractRespondToBgFromEvent;
exports.askBgScriptToFetchAuthToken = askBgScriptToFetchAuthToken;
/* Util-SmartcutsMacros Not a pure module */
